import React, { useEffect, useState } from 'react'
import { Collapse, Grid, IconButton, Typography } from '@material-ui/core'
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@material-ui/icons'

import { MoveContainerHandler, MoveContainerHandlerCallback } from 'src/scanRouter/handlers'

import { GenericCard } from '../ModelCard'

interface MoveContainerDisplayProps {
  handler: MoveContainerHandler
}

export const MoveContainerDisplay = (props: MoveContainerDisplayProps) => {
  const { handler } = props
  const [error] = useState(false)
  const [, refresh] = useState({})
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    const cb: MoveContainerHandlerCallback = () => {
      refresh({})
    }
    handler.registerCb(cb)
    return () => handler.removeCb(cb)
  }, [handler, refresh])

  return (
    <Grid container justify="center" spacing={2}>
      <Grid item xs={12}>
        <GenericCard item={handler.source} />
      </Grid>
      {handler.items.length > 1 && (
        <>
          <Grid item xs={10}>
            {expanded ? (
              <Typography>Showing {handler.items.length} containers scanned.</Typography>
            ) : (
              <Typography>
                Hiding {handler.items.length - 1} containers of {handler.items.length} scanned.
              </Typography>
            )}
          </Grid>
          <Grid item xs={2}>
            <IconButton
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
              aria-label="show more"
            >
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Grid>
        </>
      )}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {handler.items.slice(0, handler.items.length - 1).map((item) => (
          <Grid key={item.object.guid} item xs={10}>
            <GenericCard item={item} />
          </Grid>
        ))}
      </Collapse>
      <Grid item xs={12}>
        <Typography>Last scanned:</Typography>
      </Grid>
      {handler.items.length && (
        <Grid key={handler.items[handler.items.length - 1].object.guid} item xs={10}>
          <GenericCard item={handler.items[handler.items.length - 1]} />
        </Grid>
      )}
      {!!error && (
        <>
          <Grid item>
            <Typography color="error">Failed move: {error}</Typography>
          </Grid>
          <Grid item>
            <Typography>Scan to restart scan sequence</Typography>
          </Grid>
        </>
      )}
    </Grid>
  )
}
